<template>
  <footer class="main-footer">
    <div class="container">
      <div class="footer-top">
        <div>
          <h4>Newsletter Sign Up</h4>
          <p>
            Be the first to know about our newest arrivals, special offers and
            store events near you.
          </p>
          <form class="newsletter-form" @submit.prevent="subscribeNewsletter">
            <input
              type="email"
              placeholder="Enter your email"
              aria-label="Email for newsletter"
              v-model="email"
              required
            />
            <button type="submit">Go</button>
          </form>
        </div>
        <div>
          <h4>Shop</h4>
          <ul class="footer-links">
            <li>
              <router-link to="/products?category=mattresses"
                >Mattresses</router-link
              >
            </li>
            <li>
              <router-link to="/products?category=pillows">Pillows</router-link>
            </li>
            <li>
              <router-link to="/products?category=bedding">Bedding</router-link>
            </li>
            <li>
              <router-link to="/products?category=bundles">Bundles</router-link>
            </li>
          </ul>
        </div>
        <div>
          <h4>About</h4>
          <ul class="footer-links">
            <li><a href="#">Our Story</a></li>
            <li><a href="#">Reviews</a></li>
            <li><a href="#">Blog</a></li>
            <li><a href="#">Contact</a></li>
          </ul>
        </div>
        <div>
          <h4>Support</h4>
          <ul class="footer-links">
            <li><a href="#">FAQ</a></li>
            <li><a href="#">Shipping</a></li>
            <li><a href="#">Returns</a></li>
            <li><a href="#">Warranty</a></li>
          </ul>
        </div>
      </div>
      <div class="footer-bottom">
        <div>© 2024 Oshewon fabrics. All Rights Reserved.</div>
        <div class="social-icons">
          <a href="#" aria-label="Facebook">
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path
                d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"
              />
            </svg>
          </a>
          <a href="#" aria-label="Instagram">
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path
                d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.85s-.011 3.584-.069 4.85c-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07s-3.584-.012-4.85-.07c-3.252-.148-4.771-1.691-4.919-4.919-.058-1.265-.069-1.645-.069-4.85s.011-3.584.069-4.85c.149-3.225 1.664-4.771 4.919-4.919 1.266-.057 1.644-.069 4.85-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948s.014 3.667.072 4.947c.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072s3.667-.014 4.947-.072c4.358-.2 6.78-2.618 6.98-6.98.059-1.281.073-1.689.073-4.948s-.014-3.667-.072-4.947c-.2-4.358-2.618-6.78-6.98-6.98-1.281-.059-1.689-.073-4.948-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.162 6.162 6.162 6.162-2.759 6.162-6.162-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4s1.791-4 4-4 4 1.79 4 4-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.441 1.441 1.441 1.441-.645 1.441-1.441-.645-1.44-1.441-1.44z"
              />
            </svg>
          </a>
          <a href="#" aria-label="Twitter">
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path
                d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.617l-5.21-6.817-6.044 6.817h-3.308l7.73-8.835-7.994-10.66h6.772l4.643 6.209zm-1.161 17.52h1.839l-10.542-14.03h-1.98l10.683 14.03z"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { ref } from "vue";

export default {
  name: "Footer",
  setup() {
    const email = ref("");

    const subscribeNewsletter = () => {
      if (email.value) {
        alert("Thank you for subscribing to our newsletter!");
        email.value = "";
      }
    };

    return {
      email,
      subscribeNewsletter,
    };
  },
};
</script>
